import { render } from "./EntriesInput.vue?vue&type=template&id=65796897&scoped=true"
import script from "./EntriesInput.vue?vue&type=script&lang=js"
export * from "./EntriesInput.vue?vue&type=script&lang=js"

import "./EntriesInput.vue?vue&type=style&index=0&id=65796897&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65796897"]])

export default __exports__